export default __webpack_public_path__ + "img/955eede431ec7a6dd217c788486ae2e1.png";